import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'arrow-icon',
  templateUrl: './arrow-icon.component.html',
  styleUrls: ['./arrow-icon.component.scss']
})
export class ArrowIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
